import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUserRoles, hasSomeRoles, UserRole } from '../../../entities/user/domain/user.types';
import { userSelector } from '../../../entities/user/store/user.selectors';

/**
 * Custom hook for handling the submission confirmation functionality
 *
 * @returns A set of functions and state for managing submission confirmation
 */
export const useSubmissionConfirmation = () => {
  const [isSubmissionModalVisible, setIsSubmissionModalVisible] = useState(false);
  const user = useSelector(userSelector);
  const roles = getUserRoles(user);

  // Determine if the user is an admin
  const isAdmin = hasSomeRoles([UserRole.REVI_EMPLOYEE], roles) || false;

  const showSubmissionConfirmation = useCallback(() => {
    if (isAdmin) return;
    setIsSubmissionModalVisible(true);
  }, [isAdmin]);

  const hideSubmissionConfirmation = useCallback(() => {
    setIsSubmissionModalVisible(false);
  }, []);

  return {
    isSubmissionModalVisible,
    showSubmissionConfirmation,
    hideSubmissionConfirmation,
    isAdmin,
  };
};
